import type { PageWrapperProps } from './types'

import { Breadcrumb } from '../Breadcrumb'
import { LoadingPage } from '../LoadingPage'

import * as S from './styles'

export const PageWrapper = ({ children, breadcrumbData, loading }: PageWrapperProps) => {
  return (
    <S.Container>
      <Breadcrumb breadcrumbData={breadcrumbData} />

      <LoadingPage loading={loading} />

      {children}
    </S.Container>
  )
}
